import Swiper from 'swiper';
import {Pagination, Navigation, Autoplay, Thumbs, EffectFade, EffectCreative} from 'swiper/modules';

const initSliders = () => {
    const initHeroSlider = () => {

        const heroSwiper = new Swiper('.swiper--hero', {
            modules: [ Navigation, Pagination, EffectFade, Autoplay ],
            effect: "fade",
            watchOverflow: true,
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                nextEl: '.swiper--hero-button-next',
                prevEl: '.swiper--hero-button-prev',
                addIcons: false,
            },
            pagination: {
                el: '.swiper--hero-pagination',
                clickable: true,
                dynamicBullets: true,
                // type: "fraction",
                // formatFractionCurrent: (number) => number < 10 ? '0' + number : number,
                // formatFractionTotal: (number) => number < 10 ? '0' + number : number,
            },
            // watchSlidesProgress: true,
            // loop: true,
            // autoplay: {
            //     delay: 5000,
            //     disableOnInteraction: false
            // },
        });

    };

    const initSponsorsSlider = () => {
        const sponsorsSwiper = new Swiper('.swiper--sponsors', {
            modules: [ Autoplay ],
            slidesPerView: "auto",
            loop: true,
            speed: 5000,
            spaceBetween: 0,
            simulateTouch: false,
            allowTouchMove: false,
            autoplay: {
                delay: 0,
                disableOnInteraction: false
            },

        });
        // console.log('productsSwiper', productsSwiper);
        // return filmsSwiper;
    };

    const initGridSlider = () => {
        const gridSwiper = new Swiper('.swiper--grid', {
            modules: [Pagination],
            pagination: {
                el: '.swiper--grid-pagination',
                clickable: true,
                dynamicBullets: true,
            },
            watchOverflow: true,
            // autoHeight: true,
            slidesPerView: 1,
            spaceBetween: 24,
            simulateTouch: false,
            breakpoints: {
                640: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
                1280: {
                    slidesPerView: 4,
                    spaceBetween: 48,
                }
            },
        });
    }

    const initAchievementsSlider = () => {
        const gridSwiper = new Swiper('.swiper--achievements', {
            modules: [Pagination],
            pagination: {
                el: '.swiper--achievements-pagination',
                clickable: true,
                dynamicBullets: true,
            },
            watchOverflow: true,
            // autoHeight: true,
            slidesPerView: 1,
            spaceBetween: 24,
            simulateTouch: false,
            breakpoints: {
                640: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
                1280: {
                    slidesPerView: 4,
                }
            },
        });
    }

    return {
        initHeroSlider,
        initSponsorsSlider,
        initGridSlider,
        initAchievementsSlider,
    };
};

export default initSliders;
